import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout/Layout';
import HomePage from './pages/HomePage/HomePage';
import ConversionPage from './pages/ConversionPage/ConversionPage';
import ImageConvertersPage from './pages/ImageConvertersPage/ImageConvertersPage';
import StringToolsPage from './pages/StringToolsPage/StringToolsPage';
import ArrayToolsPage from './pages/ArrayToolsPage/ArrayToolsPage';
import ObjectToolsPage from './pages/ObjectToolsPage/ObjectToolsPage';
import JavaScriptTerminalPage from './pages/JavaScriptTerminalPage/JavaScriptTerminalPage';
import JavaScriptEditorPage from './pages/JavaScriptEditorPage/JavaScriptEditorPage';
import BlogPage from './pages/BlogPage/BlogPage';
import TimeToolsPage from './pages/TimeToolsPage/TimeToolsPage';
import ContactUsPage from './pages/LegalPage/ContactUsPage';
import AboutUsPage from './pages/LegalPage/AboutUsPage';
import PrivacyPolicyPage from './pages/LegalPage/PrivacyPolicyPage';
import TermsAndConditionsPage from './pages/LegalPage/TermsAndConditionsPage';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="image-converters" element={<ImageConvertersPage />} />
            <Route path="media/:conversionSlug" element={<ConversionPage />} />
            <Route path="string-tools" element={<StringToolsPage />} />
            <Route path="string-tools/:toolSlug" element={<StringToolsPage />} />
            <Route path="array-tools" element={<ArrayToolsPage />} />
            <Route path="array-tools/:toolSlug" element={<ArrayToolsPage />} />
            <Route path="javascript-object-tools" element={<ObjectToolsPage />} />
            <Route path="javascript-object-tools/:toolSlug" element={<ObjectToolsPage />} />
            <Route path="javascript-terminal" element={<JavaScriptTerminalPage />} />
            <Route path="online-javascript-editor" element={<JavaScriptEditorPage />} />
            <Route path="blogs" element={<BlogPage />} />
            <Route path="blogs/:blogSlug" element={<BlogPage />} />
            <Route path="time-tools" element={<TimeToolsPage />} />
            <Route path="about-us" element={<AboutUsPage />} />
            <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="terms-conditions" element={<TermsAndConditionsPage />} />
            <Route path="contact-us" element={<ContactUsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}
